export default [
  {
    id: 1, 
    status: "Current",         
    payPeriod: "Weekly",    
    rate: "$10.00",   
    type: "Hourly", 
    startDate: 'Wed, Jan 22, 2025',  
  },
  {
    id: 2, 
    status: "Current",         
    payPeriod: "Weekly",    
    rate: "$10.00",   
    type: "Fixed", 
    startDate: 'Wed, Jan 23, 2025',  
  },
   
   
];
